import { Timestamp as TimestampPB } from "gen/google/protobuf/timestamp_pb"

// Avoids instantiating a new collator on each call (as with localeCompare)
const collator = new Intl.Collator("en", { sensitivity: "base", numeric: true })

/**
 * Locale aware, nullish safe string comparator using a key extractor.
 * Digit runs compare numerically, so "2 - Hardware" sorts before
 * "10 - Building Materials".
 */
export function stringComparator<T>(
  keyExtractor: (t: T) => string | null | undefined
): (a: T, b: T) => number {
  return (a, b) =>
    collator.compare(keyExtractor(a) ?? "", keyExtractor(b) ?? "")
}

/**
 * Nullish safe comparator for protobuf Timestamps, oldest first.
 * A missing timestamp sorts as if it were at time zero.
 */
export function timestampComparator<T>(
  timeExtractor: (t: T) => TimestampPB | null | undefined,
  tiebreakExtractor: (t: T) => string | null | undefined
): (a: T, b: T) => number {
  return (a, b) => {
    const aTime = timeExtractor(a)
    const bTime = timeExtractor(b)
    const aMillis = aTime ? TimestampPB.toDate(aTime).getTime() : 0
    const bMillis = bTime ? TimestampPB.toDate(bTime).getTime() : 0
    if (aMillis !== bMillis) return aMillis - bMillis
    return collator.compare(
      tiebreakExtractor(a) ?? "",
      tiebreakExtractor(b) ?? ""
    )
  }
}
